import * as Scrivito from "scrivito";
import CheckboxOption from "../CheckboxOptionWidget/CheckboxOptionWidgetClass";

import {
  defaultFormInputEditingAttributes,
  defaultFormInputEditingProperties,
  defaultFormInputInitialContent,
} from "../../_defaultFormEditingConfig";

Scrivito.provideEditingConfig("CheckboxWidget", {
  title: "Checkbox",
  attributes: {
    ...defaultFormInputEditingAttributes,
  },
  properties: [...defaultFormInputEditingProperties, "checkboxOptions"],
  initialContent: {
    ...defaultFormInputInitialContent,
    checkboxOptions: [new CheckboxOption({ text: "Option 1" })],
  },
  validations: [
    [
      "csvColumnName",
      (csvColumnName) => {
        if (!csvColumnName) {
          return "CSV column name is required";
        }
        return null;
      },
    ],
  ],
});
